import React, { useMemo } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import PageHeader from '../../components/admin/PageHeader';
import OdpojeniKarta from '../../components/odpojeni/OdpojeniKarta';
import TichyRezimKarta from '../../components/odpojeni/TichyRezimKarta';
import VypadkyTabulka from '../../components/odpojeni/VypadkyTabulka';
import { useOdpojeniNastaveniQuery } from '../../api/JsdhNotifikaceService/service/OdpojeniMutations';
import { useAllUsersQuery } from '../../api/JsdhNotifikaceService/service/AdminMutations';
import { useFeatureFlags } from '../../hooks/useFeatureFlag';

/** Systém → Upozornění na odpojení (spec 2026-10-11 oddíl 7). Karty RPi a Shelly jen se zapnutým MODUL_IOT. */
const OdpojeniPage: React.FC = () => {
    const { isFeatureEnabled } = useFeatureFlags();
    const iot = isFeatureEnabled('MODUL_IOT');
    const { data: nastaveni, isLoading, error } = useOdpojeniNastaveniQuery();
    const { data: uzivatele } = useAllUsersQuery();
    const clenove = useMemo(() => (uzivatele ?? []).filter(
        // Super admin nemuze byt prijemcem (backend ho odmita); lidsky ucet ho v seznamu clenu vidi.
        (u) => u.aktivni && u.role !== 'ROLE_SUPER_ADMIN' && u.role !== 'SUPER_ADMIN',
    ), [uzivatele]);
    const karty = (nastaveni ?? []).filter((n) => n.druh === 'KIOSEK' || iot);

    return (
        <Box>
            <PageHeader
                title="Upozornění na odpojení"
                subtitle="Komu a kdy přijde upozornění, když kiosek, Raspberry Pi v objektu nebo zařízení Shelly ztratí spojení."
            />
            {isLoading && <CircularProgress />}
            {error && <Alert severity="error">Nastavení se nepodařilo načíst.</Alert>}
            <TichyRezimKarta />
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', lg: 'repeat(3, minmax(0, 1fr))' } }}>
                {karty.map((n) => <OdpojeniKarta key={n.druh} nastaveni={n} clenove={clenove} />)}
            </Box>
            <VypadkyTabulka iot={iot} />
        </Box>
    );
};

export default OdpojeniPage;
